import { useT } from '@/i18n'
import { executionMessages } from '@/i18n/messages/execution'
import type { Reason, State } from './types'

export type ExecT = ReturnType<typeof useExecT>
export function useExecT() { return useT(executionMessages) }

/** One colour per state, in lifecycle order: cool while selling, warm while building, green when done. */
export const STATE_BG: Record<State, string> = {
  offer: 'bg-sky-500', negotiation: 'bg-indigo-500', contracted: 'bg-violet-500', ready: 'bg-teal-500',
  in_progress: 'bg-amber-500', completed: 'bg-green-600', accepted: 'bg-emerald-700', closed: 'bg-neutral-700',
  lost: 'bg-rose-500', cancelled: 'bg-neutral-400',
}
const STATE_KEY = {
  offer: 'stateOffer', negotiation: 'stateNegotiation', contracted: 'stateContracted', ready: 'stateReady', in_progress: 'stateIn_progress',
  completed: 'stateCompleted', accepted: 'stateAccepted', closed: 'stateClosed', lost: 'stateLost', cancelled: 'stateCancelled',
} as const
const REASON_KEY = {
  permit: 'reasonPermit', client: 'reasonClient', material: 'reasonMaterial', design: 'reasonDesign', weather: 'reasonWeather', crew: 'reasonCrew', other: 'reasonOther',
} as const
export const stateLabel = (t: ExecT, s: State) => t(STATE_KEY[s])
export const reasonLabel = (t: ExecT, r: Reason) => t(REASON_KEY[r])

export function StateChip({ state, derived, size = 'sm' }: { state: State | null; derived?: boolean; size?: 'sm' | 'lg' }) {
  const t = useExecT()
  if (!state) return <span className="text-xs text-neutral-400">—</span>
  return (
    <span className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full font-semibold text-white ${STATE_BG[state]} ${size === 'lg' ? 'px-3 py-1 text-sm' : 'px-2 py-0.5 text-[11px]'}`}>
      {stateLabel(t, state)}
      {derived && <span className="rounded bg-white/25 px-1 text-[9px] font-bold tracking-wide" title={t('derivedLegend')}>{t('derivedShort')}</span>}
    </span>
  )
}

/** Diagonal stripes for blocked time. */
export const STRIPES = { backgroundImage: 'repeating-linear-gradient(135deg, rgba(220,38,38,.55) 0 4px, transparent 4px 8px)' }
